export const Javascript = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_3130_63395"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="20"
      height="20"
    >
      <path d="M2 2H22V22H2V2Z" fill="white" />
    </mask>
    <g mask="url(#mask0_3130_63395)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H22V22H2V2ZM17.2892 18.7667C16.3617 18.7667 15.8375 18.2833 15.435 17.625L13.9075 18.5125C14.4592 19.6025 15.5867 20.4342 17.3325 20.4342C19.1175 20.4342 20.4467 19.5075 20.4467 17.815C20.4467 16.2458 19.545 15.5483 17.9483 14.8625L17.4783 14.6617C16.6717 14.3117 16.3225 14.0842 16.3225 13.52C16.3225 13.0642 16.6725 12.715 17.2225 12.715C17.7617 12.715 18.1092 12.9425 18.4317 13.52L19.895 12.5808C19.2758 11.4917 18.4175 11.0758 17.2225 11.0758C15.5442 11.0758 14.47 12.1492 14.47 13.5592C14.47 15.0883 15.37 15.8125 16.7267 16.39L17.1967 16.5917C18.0542 16.9667 18.565 17.195 18.565 17.8392C18.565 18.3775 18.0675 18.7667 17.2892 18.7667ZM10.0058 18.7542C9.36 18.7542 9.09083 18.3125 8.79583 17.7875L7.26583 18.7142C7.70917 19.6525 8.58083 20.4308 10.085 20.4308C11.7508 20.4308 12.8917 19.545 12.8917 17.5992V11.1825H11.0125V17.5742C11.0125 18.5133 10.6225 18.7542 10.005 18.7542H10.0058Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
